import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import ReferralService from 'Services/referral';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import { QueryKeys, ReferralLinksType } from 'Types/common';

export const getReferralLinks = async (): Promise<ReferralLinksType> => {
  const response = await ReferralService.getLinks();
  const { data } = response;
  return data.item;
};

export const useFetchGetReferralLinks = (): UseQueryResult<ReferralLinksType> =>
  useQuery([QueryKeys.GET_REFERRAL_LINKS], () => getReferralLinks(), {
    onError: () => {
      history.push(routes.DASHBOARD);
    },
    refetchOnWindowFocus: false,
    cacheTime: 1,
  });
